export enum ConvertType {
    pending = 1,
    success = 2,
    fail
}

export enum LanguageType {
    zh = "zh_CN",
    en = "en_US"
}

export enum MsgStatus {
    success,
    fail,
    warn,
    wait
}

export const ORDER_DIRECTION = {
    buy: true,
    sell: false
};
